import React, { useCallback } from 'react';
import styled from 'styled-components';
import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { axiosPath, path } from '../../../../../../routing/helpers/router';
import { getState } from '../../../ResourceManager/tools/resourceManagerTools';
import Translator from '../../../../../components/helpers/Translator';
import colors from '../../../../../../constants/colors';
import errorHandler from '@/layout/components/error/ErrorHandler';

export default function ResourceObligationCard({
  resourceObligation,
  plantObligationID,
}) {
  const dispatch = useDispatch();

  // > REDIRECT TO PLANT WITH OBLIGATION FILTER
  const createFilterAndRedirect = useCallback(
    async () =>
      axios
        .post(axiosPath('api_r_user_module_resourceManager_generateFilterHexCode'), {
          moduleBridgeHex: resourceObligation?.gcl?.resourceManager?.moduleBridgeHex,
          filters: { resourceHex: resourceObligation?.resource?.hex },
        })
        .then(({ data }) => {
          if (data?.hexCode) {
            window.open(
              path({
                name: 'user_module_resourceManager_resource_home',
                params: {
                  moduleBridgeHex:
                    resourceObligation?.gcl?.resourceManager?.moduleBridgeHex,
                  page: 1,
                  filtersHex: data?.hexCode,
                },
              }),
              '_blank',
            );
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [plantObligationID, resourceObligation],
  );
  // < REDIRECT TO PLANT WITH OBLIGATION FILTER
  return (
    <>
      <Card
        className="list-group-item p-0"
        $state={getState(resourceObligation?.state)?.bgColor}
      >
        <div className="rs-status">
          <AppRemixIcon
            icon={getState(resourceObligation?.state)?.icon}
            color={getState(resourceObligation?.state)?.fgColor}
            size={20}
          />
        </div>
        <div className="rs-obligationText">{resourceObligation?.resource?.name}</div>
        <div className="rs-nextDate">
          <div
            dangerouslySetInnerHTML={{
              __html: resourceObligation?.nextDate?.nextDate,
            }}
          />
        </div>
        <div className="rs-calendar">
          {resourceObligation?.previsions?.[0] &&
            !resourceObligation?.previsions?.[0]?.currentPeriod && (
              <div title="Periodo futuro">
                <AppRemixIcon
                  icon="calendar-schedule"
                  color={
                    resourceObligation?.previsions?.[0]?.state !== 0
                      ? getState(resourceObligation?.previsions?.[0]?.state)?.bgColor
                      : '#000'
                  }
                  className="mr-2"
                />
                <span
                  key={resourceObligation?.previsions?.[0]?.id}
                  style={{
                    color:
                      resourceObligation?.previsions?.[0]?.state !== 0
                        ? getState(resourceObligation?.previsions?.[0]?.state)
                            ?.bgColor
                        : '#000',
                  }}
                  className="mr-2"
                >
                  {resourceObligation?.previsions?.[0]?.startDate} -{' '}
                  {resourceObligation?.previsions?.[0]?.endDate}
                </span>
                <AppRemixIcon
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name={
                        resourceObligation?.previsions?.[0]?.evidence?.urls?.length >
                        0
                          ? 'associated.files'
                          : 'no.associated.files'
                      }
                    />,
                  )}
                  icon="attachment-2"
                  noVariants
                  color={
                    resourceObligation?.previsions?.[0]?.evidence?.urls?.length > 0
                      ? colors.primary
                      : colors.grey400
                  }
                />
              </div>
            )}
          {resourceObligation?.previsions?.[1] &&
            resourceObligation?.previsions?.[1]?.currentPeriod && (
              <div title="Periodo actual">
                <AppRemixIcon
                  icon="calendar"
                  color={
                    getState(resourceObligation?.previsions?.[1]?.state)?.bgColor
                  }
                  className="mr-2"
                />
                <span
                  key={resourceObligation?.previsions?.[1]?.id}
                  style={{
                    color: getState(resourceObligation?.previsions?.[1]?.state)
                      ?.bgColor,
                  }}
                  className="mr-2"
                >
                  {resourceObligation?.previsions?.[1]?.startDate} -{' '}
                  {resourceObligation?.previsions?.[1]?.endDate}
                </span>
                <AppRemixIcon
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-legalCompliance"
                      name={
                        resourceObligation?.previsions?.[1]?.evidence?.urls?.length >
                        0
                          ? 'associated.files'
                          : 'no.associated.files'
                      }
                    />,
                  )}
                  icon="attachment-2"
                  noVariants
                  color={
                    resourceObligation?.previsions?.[1]?.evidence?.urls?.length > 0
                      ? colors.primary
                      : colors.grey400
                  }
                />
              </div>
            )}
        </div>
        <div className="rs-ionGrid">
          <AppRemixIcon
            icon="eye"
            color={
              resourceObligation?.gcl?.resourceManager?.hasPermission
                ? colors.primary
                : colors.grey400
            }
            className="pointer"
            onClick={() =>
              resourceObligation?.gcl?.resourceManager?.hasPermission &&
              createFilterAndRedirect()
            }
          />
        </div>
      </Card>
    </>
  );
}

const Card = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr 190px 210px 46px;
  gap: 10px;
  height: 60px;
  overflow-y: scroll;
  .rs-status {
    display: flex;
    max-height: 60px;
    background-color: ${(props) => props.$state};
    align-items: center;
    justify-content: center;
  }
  .rs-obligationText {
    border-right: 1px solid #ccc;
    overflow-y: scroll;
  }
  .rs-nextDate {
    padding: 10px;
    padding-left: 0;
    border-right: 1px solid #ccc;
    font-size: 11px;
    h3 {
      font-size: 13px;
      ${colors.primaryLight}
    }
  }
  .rs-iconGrid {
    padding: 3px;
    display: grid;
    grid-template-columns: 20px 20px;
    grid-template-rows: 20px 20px 20px 20px 20px 20px;
    height: 50px;
  }
`;
